import { render } from "./OrderRow.vue?vue&type=template&id=13bc16d7&lang=pug"
import script from "./OrderRow.vue?vue&type=script&lang=js"
export * from "./OrderRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__